import type { RoutingPredicate, SelectionRuleIn } from "@/lib/api/model";

export type FieldType = "rubric_score" | "text" | "overall_recommendation" | "yes_no" | "single_choice";
export type Evidence = "required" | "optional" | "forbidden";

export interface RubricLevel { value: number; anchor: string }

export interface ScorecardField {
  key: string;
  label: string;
  type: FieldType;
  levels?: RubricLevel[];
  options?: string[];
  required: boolean;
  evidence: Evidence;
  autofill_allowed: boolean;
  help: string | null;
}

export type SelectionRule = SelectionRuleIn;
export type { RoutingPredicate };

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  rubric_score: "Rubric score",
  text: "Free text",
  yes_no: "Yes / No",
  single_choice: "Single choice",
  overall_recommendation: "Overall recommendation",
};

export const EVIDENCE_LABELS: Record<Evidence, string> = {
  required: "Evidence required",
  optional: "Evidence optional",
  forbidden: "Human-only (no evidence)",
};

export const RECOMMENDATION_OPTIONS = ["strong_hire", "hire", "no_hire", "strong_no_hire"] as const;
export const RECOMMENDATION_LABELS: Record<(typeof RECOMMENDATION_OPTIONS)[number], string> = {
  strong_hire: "Strong hire", hire: "Hire", no_hire: "No hire", strong_no_hire: "Strong no hire",
};

export const DEFAULT_RUBRIC_LEVELS: RubricLevel[] = [
  { value: 1, anchor: "Below bar" },
  { value: 2, anchor: "Partial" },
  { value: 3, anchor: "Meets" },
  { value: 4, anchor: "Exceeds" },
];

export function defaultEventLabel(now: Date = new Date()): string {
  const d = now.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  return `Interview · ${d}`;
}

export function keyFromLabel(label: string): string {
  return label.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").replace(/^[^a-z]+/, "").slice(0, 40) || "field";
}
